import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent implements OnInit {


  @Input() delivery;
  constructor(

  ) { }

  ngOnInit(): void {
  }

}
